var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path5, _rect22, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H58L72 20V74H20V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    "clip-rue": "evenodd",
    d: "M58 4H18V76H74V20L58 4ZM58 7L71 20H58V7ZM20 74H72V22H56V6H20V74Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26L40 22V68L6 64V26Z",
    fill: "#008641"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55H26.81L23.46 48.49C23.2767 48.0606 23.1458 47.6107 23.07 47.15H23C22.8828 47.6233 22.7324 48.0878 22.55 48.54L19.21 55H14L20.19 45L14.53 35H19.85L22.63 41C22.8706 41.546 23.0646 42.1113 23.21 42.69H23.26C23.3667 42.2967 23.57 41.7167 23.87 40.95L27 35H31.88L26 44.92L32 55Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 64,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 34,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 40,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 28,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 58,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 46,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 52,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 64,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 34,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 40,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 58,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 46,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 52,
    width: 10,
    height: 4,
    fill: "#C8C8C8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 64,
    width: 2,
    height: 4,
    fill: "#C8C8C8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    width: 2,
    height: 4,
    fill: "#C8C8C8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 2,
    height: 4,
    fill: "#C8C8C8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 2,
    height: 4,
    fill: "#C8C8C8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 58,
    width: 2,
    height: 4,
    fill: "#C8C8C8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 46,
    width: 2,
    height: 4,
    fill: "#C8C8C8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 52,
    width: 2,
    height: 4,
    fill: "#C8C8C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 4H18V24.59L6 26V64L18 65.41V76H74V20L58 4Z",
    fill: "url(#paint0_linear)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 22,
    width: 16,
    height: 6,
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 74H18V65.42L40 68V74Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68L6 64V26L40 22V68Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58 4H18V6H56V22H72V50H74V20L58 4Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -20.7706,
    y1: 39.8882,
    x2: 41.5836,
    y2: 106.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5E5E5E",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 71.5067,
    y1: 27.81,
    x2: 71.5067,
    y2: 22.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#303030",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 37.701,
    y1: 74.0263,
    x2: 37.8153,
    y2: 66.8861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 38.2076,
    y1: 65.58,
    x2: 38.2076,
    y2: 24.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 59.5939,
    y1: 23.4779,
    x2: 67.2657,
    y2: 12.1079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.50f4b9e79da86669f5feae67b28307a3.svg";
export { ForwardRef as ReactComponent };